<script lang="ts">
    import { _ } from "svelte-i18n"
    import Stars from "../widgets/Stars.svelte"

    let {
        product,
    }: {
        product: Product
    } = $props()

    function checkIfUserHasRatedAndMakeSureItIsVisibleForHim(product: Product) {
        let rating = typeof window !== "undefined" ? JSON.parse(window.localStorage.getItem(product.id)) : null
        if (rating) {
            let included = false
            if (!product.ratings) product.ratings = []
            for (let i = 0; i < product.ratings.length; i++) {
                if (product.ratings[i].orderId === rating.orderId) {
                    included = true
                    product.ratings[i] = rating
                }
            }
            if (!included) {
                product.ratings.push(rating)
                if (isNaN(product.amountOfRatings)) {
                    product.amountOfRatings = 1
                    product.averageRating = rating.rating
                } else {
                    product.amountOfRatings++
                    product.averageRating =
                        (product.averageRating * (product.amountOfRatings - 1) + rating.rating) /
                        product.amountOfRatings
                }
            } else {
                product.averageRating =
                    product.ratings.reduce((acc, cur) => acc + cur.rating, 0) / product.ratings.length
                product.amountOfRatings = product.ratings.length
            }
        }
        return product
    }

    product = checkIfUserHasRatedAndMakeSureItIsVisibleForHim(product)

    let renderedRatings = $state(6)
</script>

{#if (product.ratings || []).length}
    <section aria-labelledby="customer-reviews">
        <h2 class="h3" id="customer-reviews">{$_("ratings.customer-reviews")}</h2>
        <ul>
            {#each product.ratings as rating, idx}
                {#if idx < renderedRatings}
                    <li>
                        <article>
                            <header class="review-head">
                                <Stars stars={rating.rating} identifier={`rating-${idx}`} />
                                <div class="dotted-line" aria-hidden="true"></div>
                                <p class="name">{rating.author.toUpperCase()}</p>
                            </header>

                            <p class="rating">
                                {@html rating.comment}
                            </p>
                        </article>
                    </li>
                {/if}
            {/each}
        </ul>
        {#if renderedRatings < product.ratings.length}
            <div style="width: 100%; display: flex; justify-content: center;">
                <button
                    class="button primary"
                    onclick={() => {
                        renderedRatings += 6
                    }}
                >
                    {$_("ratings.show-more")}
                </button>
            </div>
        {/if}
    </section>
{/if}

<style lang="less">
    section {
        display: flex;
        flex-direction: column;
        gap: 1.2rem;
        padding: 2.4rem 0px;
        ul {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
            gap: 2.4rem;
            li {
                article {
                    display: flex;
                    flex-direction: column;
                    gap: 0.6rem;
                    header {
                        display: flex;
                        align-items: center;
                        gap: 0.6rem;
                        .dotted-line {
                            flex: 1;
                            border-bottom: 1px dotted var(--grey-400);
                            height: 1px;
                        }
                    }
                    p {
                        margin: 0px;
                        padding: 0px;
                        font-size: var(--bodyfontsize);
                        font-weight: 400;
                    }
                    p.rating {
                        font-family: Vollkorn;
                        font-size: 1rem;
                        font-style: italic;
                    }
                }
            }
        }
    }
</style>
